import { all, call, takeLatest } from 'redux-saga/effects';

import { authSaga } from './auth/auth.saga';
import { projectSaga } from './survey/project.saga';
import common from './common';
import admin from './admin';
import { POP_NOTIFICATION } from '../constants/common/actions/notifications.constants';
import NotificationService from '../common/services/NotificationService';

function* popNotification(action) {
    yield call(NotificationService.removeNotification, action.payload);
}

export function* rootSaga() {
    yield all([
        ...authSaga,
        ...projectSaga,
        ...common,
        ...admin,
        takeLatest(POP_NOTIFICATION, popNotification),
    ]);
}
